import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useParams } from "react-router-dom";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import Table from "../../../Components/Table";
import { ListarConfigEnvelopeController } from "../../../Controllers/Geral/ConfigEnvelope/ConfigEnvelopeControllers";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { IConfigEnvelope } from "../../../Interfaces/Geral/ConfigEnvelope/ConfigEnvelopeInterfaces";
import ConfigDeEnvelopeDaGestao from "./ConfigDeEnvelopeDaGestao";
import CriarConfigDeEnvelope from "./CriarConfigDeEnvelope";
import EditarConfigDeEnvelope from "./EditarConfigDeEnvelope";
import SelecaoProdutoConfigEnvelope from "./SelecaoProdutoConfigEnvelope";

interface IGestaoConfigDeEnvelopeProps {}
interface IGestaoConfigDeEnvelopeRouteParams {
    idProduto: string;
}
export default function GestaoConfigDeEnvelope(
    props: IGestaoConfigDeEnvelopeProps
) {
    const idProduto = Number(
        useParams<IGestaoConfigDeEnvelopeRouteParams>().idProduto
    );

    const {
        loading,
        value: lstConfigEnvelope,
        execute: updateList,
    } = useAsyncEffect(
        () => ListarConfigEnvelopeController(idProduto),
        [idProduto]
    );

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [idConfigEnvelopeSendoEditada, setIdConfigEnvelopeSendoEditada] =
        useState<number>();

    const tableColumns: Array<ColumnDescription<IConfigEnvelope>> = [
        {
            dataField: "DS_ENVELOPE",
            text: "Configurações",
            formatter: (c, row) => (
                <ConfigDeEnvelopeDaGestao
                    configEnvelope={row}
                    onDelete={updateList}
                    onEditClick={() => {
                        setIdConfigEnvelopeSendoEditada(
                            row.ID_ENVELOPE_DOCUSIGN_CONFIG
                        );
                    }}
                />
            ),
            sort: true,
        },
    ];

    useEffect(() => {
        if (idConfigEnvelopeSendoEditada) {
            setModal({
                Component: () => (
                    <EditarConfigDeEnvelope
                        idConfigEnvelope={idConfigEnvelopeSendoEditada}
                        updateList={updateList}
                        idProduto={idProduto}
                    />
                ),
                noHeader: true,
                noBody: true,
                size: "xl",
                onClose: () => setIdConfigEnvelopeSendoEditada(undefined),
            });
            setShow(true);
        }
    }, [idConfigEnvelopeSendoEditada, updateList, idProduto]);

    return (
        <div>
            <div className="card card-custom" id="kt_page_sticky_card">
                <div className="card-header border-0 pt-5">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder text-dark gruposTitle">
                            Configurações de Envelope do empreendimento
                        </span>
                    </h3>
                    <div className="card-toolbar">
                        <button
                            className="btn btn-success font-weight-bold mr-2"
                            onClick={() => {
                                setModal({
                                    Children: (
                                        <CriarConfigDeEnvelope
                                            idProduto={idProduto}
                                            onCreate={(id) => {
                                                setShow(false);
                                                updateList();
                                                setIdConfigEnvelopeSendoEditada(
                                                    id
                                                );
                                            }}
                                        />
                                    ),
                                    headerComponent:
                                        "Cadastrar Configuração de Envelope",
                                });
                                setShow(true);
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faPlus}
                                size="lg"
                                className="mr-2"
                            />{" "}
                            Nova Configuração
                        </button>
                    </div>
                </div>
                <div className="card-body pt-2 pb-0 mt-n3">
                    <div className="table-responsive-sm">
                        <Table
                            keyField="ID_ENVELOPE_DOCUSIGN_CONFIG"
                            data={lstConfigEnvelope ?? []}
                            columns={tableColumns}
                            noDataIndication={
                                <div className="text-center text-muted">
                                    Nenhuma configuração de envelope para esse
                                    produto
                                </div>
                            }
                            loading={loading}
                        />
                    </div>
                </div>
            </div>

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />

            <SelecaoProdutoConfigEnvelope idProduto={idProduto} />
        </div>
    );
}
